

<template>
  <div class="vcard">
    <div class="type-1 flex-center">
      <div>
        <img class="avatar" :src="avatar" />
      </div>
      <div style="padding-left: 12px;">
        <div class="t-name flex-center">
          <span class="van-ellipsis name-left">{{ name }}</span>
          <span>{{ position }}</span>
          <img
            src="https://img.esenyun.com/images/20200813/6c150633d2874b18a09d165f3aef3c38.png"
            style="width: 12px;height: 12px;margin-left :2px;"
          />
        </div>
        <div class="t-sub">联系服务顾问，了解更多</div>
      </div>
      <div
        class="flex-center"
        style="flex: 1;justify-content:flex-end;margin-right: 20px;"
      >
        <div class="opt-icon flex-center" @click="makePhone">
          <img
            src="https://img.esenyun.com/images/20200602/542b83e4257c4030acb64662b7a6de41.png"
          />
        </div>
      </div>
      <div class="opt-icon flex-center" @click="showVcard">
        <img
          src="https://img.esenyun.com/images/20200602/0a45d8d030f84ff2b7274ac7fb8db648.png"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['posterData'],
  data() {
    return {
      avatar: '',
      name: '',
      position: '',
      company: '',
      mobile: '',
    }
  },
  mounted() {
    this.avatar = this.posterData.avatar
    console.log(223, this.avatar)
    this.name = this.posterData.name
    this.position = this.posterData.position
    this.company = this.posterData.company || 'A.O.史密斯'
    this.mobile = this.posterData.mobile
    this.qrCode = this.posterData.liveQrCode||this.posterData.qrCode
  },
  methods: {
    showVcard(){
        this.$emit('showVcard')
    },
    // 打电话
    makePhone() {
      window.location.href = `tel:${this.mobile}`
    },
  },
}
</script>

<style lang="less" scoped>
.forward_text {
  padding: 24px 0 16px 0;
  color: #000;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  text-align: center;
  .arrow {
    display: inline-block;
    width: 0;
    height: 0;
    border-top: 8px solid #7d7e80;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    margin: 0 6px;
  }
}
.show_vcard {
  height: 218px;
  margin-top: 56px;
  box-shadow: 2px 4px 12px rgba(0, 0, 0, 0.08);
  background: #fff;
  border-radius: 5px;
  .title {
    position: relative;
    height: 138px;
    background: url('https://img.esenyun.com/images/20200602/1da422ddd2e641f697d619590d9340dd.png')
      no-repeat;
    background-size: 100%;
    .logo {
      text-align: center;
      position: relative;
      height: 38px;
      top: -30%;
      .logo-container {
        width: 76px;
        height: 76px;
        display: inline-block;
        border-radius: 50%;
        // margin-top: -38px;
        border: 4px solid #fff;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .name {
    margin-top: 12px;
    text-align: center;
    font-size: 20px;
    line-height: 28px;
    color: #fff;
  }
  .sub {
    font-size: 14px;
    line-height: 22px;
    color: #fff;
    margin-top: 7px;
    text-align: center;
  }
  .phone {
    font-size: 20px;
    line-height: 24px;
    margin-left: 20px;
    img {
      width: 20px;
      height: 20px;
      margin-right: 4px;
    }
  }
  .opt-icon {
    width: 40px;
    height: 40px;
    justify-content: center;
    margin-right: 20px;
    text-align: center;
    border-radius: 50%;
    background: #ebf2ff;
    img {
      width: 20px;
      height: 20px;
    }
  }
}
.opt-icon {
  width: 40px;
  height: 40px;
  justify-content: center;
  text-align: center;
  border-radius: 50%;
  background: #ebf2ff;
  img {
    width: 20px;
    height: 20px;
  }
}
.type-1 {
  height: 64px;
  font-size: 14px;
  .avatar {
    border: 1px solid #dcdde0;
    width: 46px;
    height: 46px;
    border-radius: 50%;
  }
  .t-name {
    line-height: 22px;
    .name-left {
      max-width: 100rpx;
      margin-right: 4px;
    }
  }
  .t-sub {
    font-size: 12px;
    line-height: 20px;
    color: #7d7e80;
  }
}
</style>
